<script lang="ts">
    import dayjs from 'dayjs'
    import _isToday from 'dayjs/plugin/isToday'
    dayjs.extend(_isToday)
    import { onMount } from 'svelte'
    import type { Channel } from '../../../modules/brokerApi/channels/channel'
    import { ChannelsRepository } from '../../../modules/brokerApi/channels/channels.repository'
    import { ChannelsService } from '../../../modules/brokerApi/channels/channels.service'
    import type { EventSource } from '../../../modules/eventsApi/event-sources/event-source.entity'
    import { EventSourcesRepository } from '../../../modules/eventsApi/event-sources/event-sources.repository'
    import { EventSourcesService } from '../../../modules/eventsApi/event-sources/event-sources.service'

    const esRep: EventSourcesRepository = new EventSourcesRepository()
    const esS: EventSourcesService = new EventSourcesService(esRep)
    const channelsRep: ChannelsRepository = new ChannelsRepository()
    const channelsS: ChannelsService = new ChannelsService(channelsRep)

    let d = new Date()
    d.setHours(0, 0, 0, 0)

    export let personId: string
    export let startDate: Date = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 45)

    let source: string = 'whatsapp'

    let eventSources: EventSource[] = []
    let query = ''
    let show = false
    let dates: { from: Date; to: Date } = window.api.utils.dates.today()
    if (startDate) dates.from = startDate

    let channels: Channel[] = []
    let personChannels: Channel[] = []

    async function loadLogs() {
        show = true
        try {
            personChannels = []
            eventSources = []
            if (!personId) return
            let from = dates.from
            from.setHours(0)
            from.setMinutes(0)
            from.setSeconds(0)
            let to = dates.to
            to.setHours(23)
            to.setMinutes(59)
            to.setSeconds(59)
            eventSources = await esS.getAll({ from, to, personId, query, sources: source })
            for (const es of eventSources) {
                if (!personChannels.find((el) => el.channelId === es.channelId)) {
                    const found = channels.find((el) => el.channelId === es.channelId)
                    if (found) {
                        personChannels.push(found)
                    }
                }
            }
            if (!channelId) {
                if (personChannels.length === 1) {
                    channelId = personChannels[0].channelId
                }
            }
            personChannels = personChannels
            console.log('Person eventSources', eventSources)
        } catch (error) {
        } finally {
            show = false
        }
    }

    let channelId: string = null
    async function loadChannels() {
        channels = await channelsS.getAll()
    }

    function setChannel(id) {
        channelId = id
        eventSources = eventSources
    }

    function escapeText(text) {
        text.replace(/[&<>"'/]/g, function (s) {
            var entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '\n': '< br/>',
                '/': '&#x2F;',
            }
            return entityMap[s]
        })
        return text
    }

    function markText(text) {
        if (!text) return ''
        let regex = /\*(.*?)\*/g
        text = text.replace(regex, '<strong>$1</strong>')
        regex = /_(.*?)_/g
        text = text.replace(regex, '<i>$1</i>')
        regex = /~(.*?)~/g
        text = text.replace(regex, '<strike>$1</strike>')
        text = text.replace(/\n/g, '<br />')
        text = linkify(text)
        return text
    }

    function linkify(text) {
        var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi
        return text.replace(urlRegex, function (url) {
            return '<a target="_blank" href="' + url + '">' + url + '</a>'
        })
    }

    function messageDate(contact: EventSource) {
        if (dayjs(contact.externalDate).isToday()) {
            return dayjs(contact.externalDate).format('HH:mm')
        } else {
            return dayjs(contact.externalDate).format('DD/MM/YY HH:mm')
        }
    }

    onMount(async () => {
        await loadChannels()
    })

    $: {
        if (personId) {
            loadLogs()
        }

        dates.from = startDate
    }
</script>

<div class="chat">
    <div class="channels">
        {#each personChannels as channel}
            <div class="button" class:selected={channel.channelId === channelId} on:click={() => setChannel(channel.channelId)}>
                {channel.label}
            </div>
        {/each}
    </div>
    <div class="messages scroll-dark">
        {#each eventSources as es, index}
            {#if es.person.personId === personId && es.channelId === channelId}
                <div class="message" class:me={es.event[0].event === 'comunicacao_enviada'}>
                    <div class="">{@html escapeText(markText(es.content))}</div>
                    <div class="date">{messageDate(es)}</div>
                </div>
            {/if}
        {/each}
    </div>
</div>

<style>
    .chat {
        display: flex;
        align-items: stretch;
        height: 100%;
    }
    .chat .channels {
        flex: 0 0 200px;
        background: #292929;
        height: 100%;
    }
    .chat .channels .button {
        color: #ddd;
        background: #292929;
        padding: 6px 4px;
        cursor: pointer;
    }
    .chat .channels .button:hover {
        background: #2c2c2c;
    }
    .chat .channels .selected {
        background: #212121;
    }
    .chat .messages {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column-reverse;
        padding: 0px 4px 0px 4px;
        padding-bottom: 100px;
        background-color: #212121;
        overflow-y: auto;
    }
    .chat .messages .message {
        margin: 6px;
        max-width: 80%;
        padding: 6px;
        font-size: 14px;
        background: #262626;
        border-radius: 4px;
    }
    .chat .messages .message :global(a) {
        text-decoration: underline;
    }
    .chat .messages .me {
        align-self: flex-end;
        background: #333;
    }
    .chat .messages .content {
        color: #eee;
        padding-bottom: 4px;
    }
    .chat .messages .date {
        font-size: 12px;
        color: #aaa;
    }
</style>
